import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="page contact-page">
      <Helmet>
        <title>{t('navbar.contact')} - TA2GBO</title>
      </Helmet>
      <h2>{t('contact.title')}</h2>
      <div className="contact-content">
        <div className="contact-list">
          <a href="mailto:ta2gbo@gmail.com" className="contact-item">
            <i className="fas fa-envelope"></i>
            <span>{t('contact.email')}: ta2gbo@gmail.com</span>
          </a>
          <a href="https://www.youtube.com/@TA2GBO" target="_blank" rel="noopener noreferrer" className="contact-item">
            <i className="fab fa-youtube"></i>
            <span>{t('contact.youtube')}: TA2GBO </span>
          </a>
          <a href="https://www.instagram.com/ta2gbo" target="_blank" rel="noopener noreferrer" className="contact-item">
            <i className="fab fa-instagram"></i>
            <span>{t('contact.instagram')}: @ta2gbo</span>
          </a>
          <a href="https://www.qrz.com/db/TA2GBO" target="_blank" rel="noopener noreferrer" className="contact-item">
            <i className="fas fa-broadcast-tower"></i>
            <span>{t('contact.qrz')}: TA2GBO</span>
          </a>
          <div className="contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <span>{t('contact.grid')}: KM69kv, KM39bt</span>
          </div>
        </div>
        <div className="map-container">
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://www.openstreetmap.org/export/embed.html?bbox=10.0,25.0,55.0,55.0&amp;layer=mapnik&amp;marker=39.958,32.833"
            title="TA2GBO Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;